<div class="table-responsive">
  <table class="table project-table">
    <thead>
      <tr>
        <th class="project-table-year-col">Year</th>
        <th class="project-table-title-col">Project</th>
        <th class="project-table-hood-col">Neighborhood</th>
        <th class="project-table-designer-col">Designer</th>
      </tr>
    </thead>
    <tbody>
      <slot></slot>
    </tbody>
  </table>
</div>
